module.exports = __webpack_public_path__ + "static/media/bg_TY.71924f8e.jpg";